export const EMPTY_ARRAY = [];
export const EMPTY_OBJECT = {};
export const EMPTY_FUNCTION = () => undefined;
